import axios from 'axios';

import { localhostApi } from '../../../constants';
import type { Flow } from '../../../modules/Auth0/types';
import { mapError } from '../../../modules/Auth0/utils/mapError';
import type { Analytics } from '../../../modules/analytics/types';
import { isLocalHost } from '../../../utils/isLocalHost';

export default async function isChallengedByCloudFlare(
  { trackLink }: Analytics,
  flow: Flow,
): Promise<boolean> {
  try {
    const URL = `${
      isLocalHost() ? localhostApi : window.location.origin
    }/challenge`;

    const res = await axios.get(URL, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return Promise.resolve(res.data?.challenge_required);
  } catch (error: any) {
    const reason = mapError(
      {
        code: 'recaptcha_error',
        error: 'error_calling_cloudflare_bot',
      },
      trackLink,
      `${flow}.error_calling_cloudflare_bot`,
    );
    return Promise.reject(reason);
  }
}
